/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import preview from 'ui/components/theme/preview.mixin';

const __vue_script__ = {
    name: 'MobilePreview',

    mixins: [preview],

    data() {
        return {
            pageTop: 32,
            createPostBoxHeight: 40,
            quickLinksHeight: 60,
            pinnedPostHeight: 70,
        };
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-preview" }, [
    _c("div", { staticClass: "home" }, [
      _c("h4", [_vm._v(_vm._s(_vm.$t("theme.editor.previews.mobile_home")))]),
      _c(
        "svg",
        {
          attrs: {
            viewBox: "0 0 232 450",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c(
            "g",
            {
              staticClass: "home_page",
              attrs: { "clip-path": "url(#clip_page_radius)" },
            },
            [
              _c("rect", {
                staticClass: "page_background",
                attrs: {
                  width: "232",
                  height: "450",
                  rx: "8",
                  fill: _vm.backgroundColor4 || _vm.color8,
                },
              }),
              _vm.banner
                ? _c(
                    "g",
                    {
                      staticClass: "banner",
                      attrs: { transform: "translate(0 " + _vm.pageTop + ")" },
                    },
                    [
                      _c("image", {
                        ref: "banner",
                        attrs: {
                          href: _vm.banner,
                          width: "232",
                          x: "0",
                          y: "0",
                          preserveAspectRatio: "xMaxYMax meet",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _c(
                "g",
                {
                  staticClass: "create_post_box",
                  attrs: {
                    transform: "translate(0 " + _vm.createPostBoxTop + ")",
                  },
                },
                [
                  _c("rect", {
                    attrs: {
                      x: "8.25",
                      y: "0.25",
                      width: "215.5",
                      height: "39.5",
                      rx: "3.75",
                      fill: _vm.backgroundColor3 || "#FFFFFF",
                    },
                  }),
                  _c("circle", {
                    attrs: { cx: "30", cy: "20", r: "12", fill: _vm.color1 },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M23.8838 24H24.9482V18.883H25.0264L28.6445 24H29.6309V16.954H28.5664V22.081H28.4932L24.8701 16.954H23.8838V24ZM33.7861 24.171C35.4268 24.171 36.4766 23.331 36.4766 21.983V21.979C36.4766 20.934 35.8711 20.338 34.3916 20.021L33.625 19.85C32.7119 19.654 32.3408 19.312 32.3408 18.79V18.785C32.3408 18.121 32.9512 17.735 33.7764 17.735C34.6309 17.73 35.1826 18.15 35.2754 18.727L35.2852 18.79H36.3447L36.3398 18.722C36.2617 17.628 35.2852 16.783 33.791 16.783C32.2969 16.783 31.2422 17.623 31.2373 18.839V18.844C31.2373 19.884 31.8525 20.548 33.2832 20.851L34.0547 21.017C34.9873 21.217 35.3682 21.568 35.3682 22.11V22.115C35.3682 22.77 34.7285 23.219 33.8301 23.219C32.8877 23.219 32.209 22.809 32.1504 22.169L32.1455 22.115H31.0713L31.0762 22.179C31.1738 23.365 32.1943 24.171 33.7861 24.171Z",
                      fill: _vm.color2,
                    },
                  }),
                  _c("rect", {
                    attrs: {
                      x: "50",
                      y: "16",
                      width: "46",
                      height: "8",
                      rx: "2",
                      fill: "#E5E6E6",
                    },
                  }),
                  _c("rect", {
                    attrs: {
                      x: "175",
                      y: "10",
                      width: "40",
                      height: "20",
                      rx: "4",
                      fill: _vm.isV3 ? _vm.brandColor : _vm.color1,
                    },
                  }),
                  _c("rect", {
                    attrs: {
                      x: "8.25",
                      y: "0.25",
                      width: "215.5",
                      height: "39.5",
                      rx: "3.75",
                      stroke: _vm.backgroundColor2 || "#E5E6E6",
                      "stroke-width": "0.5",
                    },
                  }),
                ]
              ),
              _vm.quickLinks
                ? _c(
                    "g",
                    {
                      staticClass: "quick_links",
                      attrs: {
                        transform: "translate(0 " + _vm.quickLinksTop + ")",
                      },
                    },
                    [
                      _c(
                        "g",
                        { attrs: { "clip-path": "url(#clip_quick_links)" } },
                        [
                          _vm._l(_vm.quickLinks, function (i) {
                            return [
                              _c("rect", {
                                attrs: {
                                  x: 8.25 + 60 * (i - 1),
                                  y: 0.25,
                                  width: "53.5",
                                  height: "59.5",
                                  rx: "3.75",
                                  fill: _vm.backgroundColor3 || "#FFFFFF",
                                },
                              }),
                              _c("rect", {
                                attrs: {
                                  x: 14.2998 + 60 * (i - 1),
                                  y: 37,
                                  width: "41.4",
                                  height: "8",
                                  rx: "2",
                                  fill: "#E5E6E6",
                                },
                              }),
                              _c("ellipse", {
                                attrs: {
                                  cx: 35 + 60 * (i - 1),
                                  cy: 22,
                                  rx: "9",
                                  ry: "9",
                                  fill: "#E5E6E6",
                                },
                              }),
                              _c("rect", {
                                attrs: {
                                  x: 8.25 + 60 * (i - 1),
                                  y: 0.25,
                                  width: "53.5",
                                  height: "59.5",
                                  rx: "3.75",
                                  stroke: _vm.backgroundColor2 || "#E5E6E6",
                                  "stroke-width": "0.5",
                                },
                              }),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.pinnedPost
                ? _c(
                    "g",
                    {
                      staticClass: "pinned_post",
                      attrs: {
                        transform: "translate(8 " + _vm.pinnedPostTop + ")",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "0.25",
                          y: "0.25",
                          width: "215.5",
                          height: "69.5",
                          rx: "3.75",
                          fill: _vm.backgroundColor3 || "#FFFFFF",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "0.25",
                          y: "0.25",
                          width: "215.5",
                          height: "69.5",
                          rx: "3.75",
                          stroke: _vm.backgroundColor2 || "#E5E6E6",
                          "stroke-width": "0.5",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M10.11 24.89C10.1805 24.961 10.275 25 10.375 25C10.475 25 10.5695 24.961 10.64 24.8905L14.3783 21.1527L16.1662 22.9411C16.3782 23.1536 16.6607 23.2711 16.9627 23.2716C17.2627 23.2716 17.5447 23.1551 17.7567 22.9436C17.8247 22.8756 17.8842 22.7986 17.9337 22.7146C18.4231 21.8721 18.5991 20.8892 18.4336 19.9337L21.4795 17.9953C21.7325 17.8343 21.908 17.5838 21.9735 17.2903C22.0385 16.9968 21.986 16.6958 21.825 16.4429C21.781 16.3744 21.7295 16.3099 21.671 16.2509L18.7496 13.3295C18.5371 13.117 18.2547 13 17.9542 13C17.6537 13 17.3712 13.117 17.1592 13.3295C17.1012 13.387 17.0497 13.4515 17.0052 13.521L15.0668 16.5679C14.8328 16.5274 14.5958 16.5069 14.3598 16.5069C13.6348 16.5069 12.9179 16.7008 12.2849 17.0688C12.0254 17.2208 11.8409 17.4648 11.7654 17.7558C11.6899 18.0468 11.7319 18.3498 11.8839 18.6088C11.9324 18.6918 11.9919 18.7683 12.0594 18.8358L13.8468 20.6232L10.11 24.36C10.039 24.4305 10 24.525 10 24.625C10 24.725 10.039 24.8195 10.11 24.89ZM12.6629 17.7168C13.1799 17.4163 13.7668 17.2573 14.3598 17.2573C14.6268 17.2573 14.8948 17.2888 15.1563 17.3518C15.1848 17.3588 15.2143 17.3623 15.2438 17.3623C15.3728 17.3623 15.4908 17.2978 15.5603 17.1888L17.6377 13.924C17.6527 13.901 17.6697 13.8795 17.6892 13.86C17.7597 13.789 17.8542 13.75 17.9542 13.75C18.0547 13.75 18.1487 13.789 18.2197 13.86L21.14 16.7813C21.1595 16.8008 21.177 16.8223 21.1915 16.8453C21.245 16.9298 21.2625 17.0303 21.241 17.1278C21.219 17.2258 21.1605 17.3088 21.076 17.3628L17.8117 19.4402C17.6767 19.5262 17.6112 19.6887 17.6487 19.8442C17.8537 20.6952 17.7242 21.5806 17.2847 22.3366C17.2687 22.3641 17.2492 22.3891 17.2262 22.4121C17.1557 22.4826 17.0617 22.5211 16.9617 22.5211C16.8612 22.5211 16.7667 22.4821 16.6957 22.4111L12.5889 18.3043C12.5664 18.2818 12.5469 18.2568 12.5304 18.2288C12.4799 18.1428 12.4654 18.0418 12.4909 17.9448C12.5164 17.8478 12.5779 17.7668 12.6629 17.7168Z",
                          fill: _vm.brandColor,
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M10.11 24.89L10.4648 24.5377L10.4623 24.5352L10.11 24.89ZM10.64 24.8905L10.2864 24.5369L10.2864 24.537L10.64 24.8905ZM14.3783 21.1527L14.7319 20.7992L14.3784 20.4455L14.0248 20.7991L14.3783 21.1527ZM16.1662 22.9411L16.5202 22.5879L16.5198 22.5876L16.1662 22.9411ZM16.9627 23.2716L16.9619 23.7716H16.9627V23.2716ZM17.7567 22.9436L18.1098 23.2976L18.1102 23.2971L17.7567 22.9436ZM17.9337 22.7146L18.3644 22.9684L18.366 22.9658L17.9337 22.7146ZM18.4336 19.9337L18.1652 19.5119L17.8841 19.6908L17.941 20.019L18.4336 19.9337ZM21.4795 17.9953L21.2111 17.5735L21.2111 17.5735L21.4795 17.9953ZM21.9735 17.2903L22.4615 17.3992L22.4617 17.3984L21.9735 17.2903ZM21.825 16.4429L22.2468 16.1744L22.2457 16.1726L21.825 16.4429ZM21.671 16.2509L22.0261 15.8988L22.0246 15.8973L21.671 16.2509ZM18.7496 13.3295L18.3961 13.683V13.683L18.7496 13.3295ZM17.1592 13.3295L17.5112 13.6846L17.5132 13.6826L17.1592 13.3295ZM17.0052 13.521L16.5841 13.2514L16.5833 13.2526L17.0052 13.521ZM15.0668 16.5679L14.9815 17.0605L15.3098 17.1173L15.4887 16.8362L15.0668 16.5679ZM12.2849 17.0688L12.0336 16.6366L12.0322 16.6374L12.2849 17.0688ZM11.8839 18.6088L12.3156 18.3565L12.3151 18.3557L11.8839 18.6088ZM12.0594 18.8358L11.7059 19.1893H11.7059L12.0594 18.8358ZM13.8468 20.6232L14.2004 20.9767L14.5539 20.6232L14.2004 20.2696L13.8468 20.6232ZM10.11 24.36L10.4623 24.7148L10.4635 24.7136L10.11 24.36ZM12.6629 17.7168L12.4116 17.2845L12.4094 17.2858L12.6629 17.7168ZM15.1563 17.3518L15.2755 16.8662L15.2734 16.8657L15.1563 17.3518ZM15.5603 17.1888L15.9819 17.4576L15.9821 17.4572L15.5603 17.1888ZM17.6377 13.924L17.2189 13.6508L17.2158 13.6555L17.6377 13.924ZM17.6892 13.86L18.0427 14.2135L18.044 14.2123L17.6892 13.86ZM18.2197 13.86L18.5733 13.5065L18.5732 13.5064L18.2197 13.86ZM21.14 16.7813L20.7864 17.1348L20.7865 17.1349L21.14 16.7813ZM21.1915 16.8453L20.7686 17.112L20.7691 17.1128L21.1915 16.8453ZM21.241 17.1278L21.7289 17.2373L21.7293 17.2355L21.241 17.1278ZM21.076 17.3628L21.3445 17.7846L21.3453 17.7841L21.076 17.3628ZM17.8117 19.4402L17.5432 19.0184L17.543 19.0185L17.8117 19.4402ZM17.6487 19.8442L18.1348 19.7271L18.1347 19.727L17.6487 19.8442ZM17.2847 22.3366L17.7169 22.5881L17.717 22.5879L17.2847 22.3366ZM17.2262 22.4121L16.8726 22.0586L16.8726 22.0586L17.2262 22.4121ZM16.6957 22.4111L17.0493 22.0576L16.6957 22.4111ZM12.5889 18.3043L12.2353 18.6578L12.5889 18.3043ZM12.5304 18.2288L12.0992 18.482L12.0996 18.4826L12.5304 18.2288ZM12.4909 17.9448L12.0073 17.8177L12.0073 17.8177L12.4909 17.9448ZM10.375 24.5C10.4071 24.5 10.4406 24.5134 10.4648 24.5377L9.75519 25.2423C9.92035 25.4086 10.1429 25.5 10.375 25.5V24.5ZM10.2864 24.537C10.3102 24.5132 10.3431 24.5 10.375 24.5V25.5C10.6069 25.5 10.8288 25.4088 10.9935 25.2441L10.2864 24.537ZM14.0248 20.7991L10.2864 24.5369L10.9935 25.2441L14.7318 21.5062L14.0248 20.7991ZM16.5198 22.5876L14.7319 20.7992L14.0247 21.5062L15.8126 23.2946L16.5198 22.5876ZM16.9635 22.7716C16.7937 22.7713 16.6383 22.7063 16.5202 22.5879L15.8123 23.2942C16.1182 23.6008 16.5278 23.7709 16.9619 23.7716L16.9635 22.7716ZM17.4035 22.5896C17.2855 22.7074 17.1306 22.7716 16.9627 22.7716V23.7716C17.3948 23.7716 17.8039 23.6027 18.1098 23.2976L17.4035 22.5896ZM17.5029 22.4607C17.4745 22.5089 17.4408 22.5523 17.4031 22.59L18.1102 23.2971C18.2085 23.1988 18.2938 23.0882 18.3644 22.9684L17.5029 22.4607ZM17.941 20.019C18.0864 20.8585 17.9319 21.7224 17.5013 22.4634L18.366 22.9658C18.9144 22.0219 19.1119 20.9198 18.9263 19.8484L17.941 20.019ZM21.2111 17.5735L18.1652 19.5119L18.7021 20.3555L21.748 18.4171L21.2111 17.5735ZM21.4855 17.1814C21.4488 17.3461 21.3519 17.4838 21.2111 17.5735L21.748 18.4171C22.1131 18.1848 22.3673 17.8215 22.4615 17.3992L21.4855 17.1814ZM21.4032 16.7113C21.4926 16.8518 21.5219 17.0173 21.4853 17.1822L22.4617 17.3984C22.5551 16.9764 22.4794 16.5399 22.2468 16.1744L21.4032 16.7113ZM21.316 16.6029C21.3495 16.6367 21.3791 16.6737 21.4043 16.7131L22.2457 16.1726C22.183 16.075 22.1095 15.983 22.0261 15.8988L21.316 16.6029ZM18.3961 13.683L21.3175 16.6044L22.0246 15.8973L19.1032 12.9759L18.3961 13.683ZM17.9542 13.5C18.1221 13.5 18.2774 13.5643 18.3961 13.683L19.1032 12.9759C18.7969 12.6697 18.3873 12.5 17.9542 12.5V13.5ZM17.5132 13.6826C17.6311 13.5644 17.7862 13.5 17.9542 13.5V12.5C17.5212 12.5 17.1113 12.6696 16.8052 12.9763L17.5132 13.6826ZM17.4263 13.7906C17.4522 13.7502 17.4808 13.7147 17.5112 13.6846L16.8072 12.9744C16.7216 13.0593 16.6473 13.1528 16.5841 13.2514L17.4263 13.7906ZM15.4887 16.8362L17.4271 13.7894L16.5833 13.2526L14.6449 16.2995L15.4887 16.8362ZM14.3598 17.0069C14.5669 17.0069 14.7754 17.0249 14.9815 17.0605L15.1521 16.0752C14.8902 16.0299 14.6247 16.0069 14.3598 16.0069V17.0069ZM12.5362 17.5011C13.0935 17.1771 13.7239 17.0069 14.3598 17.0069V16.0069C13.5458 16.0069 12.7422 16.2246 12.0336 16.6366L12.5362 17.5011ZM12.2494 17.8814C12.2915 17.7191 12.3928 17.5851 12.5376 17.5003L12.0322 16.6374C11.6581 16.8565 11.3903 17.2106 11.2815 17.6302L12.2494 17.8814ZM12.3151 18.3557C12.2304 18.2112 12.2071 18.0445 12.2494 17.8814L11.2815 17.6302C11.1728 18.0491 11.2335 18.4883 11.4527 18.8618L12.3151 18.3557ZM12.413 18.4822C12.3749 18.4441 12.3419 18.4015 12.3156 18.3565L11.4522 18.861C11.5229 18.982 11.6089 19.0924 11.7059 19.1893L12.413 18.4822ZM14.2004 20.2696L12.413 18.4822L11.7059 19.1893L13.4933 20.9767L14.2004 20.2696ZM10.4635 24.7136L14.2004 20.9767L13.4933 20.2696L9.75644 24.0065L10.4635 24.7136ZM10.5 24.625C10.5 24.6571 10.4866 24.6907 10.4623 24.7148L9.75769 24.0052C9.59137 24.1704 9.5 24.3929 9.5 24.625H10.5ZM10.4623 24.5352C10.4866 24.5594 10.5 24.5929 10.5 24.625H9.5C9.5 24.8571 9.59137 25.0797 9.75769 25.2448L10.4623 24.5352ZM14.3598 16.7573C13.6778 16.7573 13.0042 16.9401 12.4116 17.2845L12.9141 18.1491C13.3555 17.8925 13.8559 17.7573 14.3598 17.7573V16.7573ZM15.2734 16.8657C14.9733 16.7934 14.666 16.7573 14.3598 16.7573V17.7573C14.5876 17.7573 14.8163 17.7842 15.0392 17.8379L15.2734 16.8657ZM15.2438 16.8623C15.2536 16.8623 15.2641 16.8635 15.2755 16.8663L15.037 17.8374C15.1054 17.8542 15.175 17.8623 15.2438 17.8623V16.8623ZM15.1387 16.92C15.1612 16.8847 15.2023 16.8623 15.2438 16.8623V17.8623C15.5432 17.8623 15.8203 17.7109 15.9819 17.4576L15.1387 16.92ZM17.2158 13.6555L15.1384 16.9204L15.9821 17.4572L18.0595 14.1924L17.2158 13.6555ZM17.3356 13.5064C17.2888 13.5532 17.2504 13.6024 17.2189 13.6508L18.0565 14.1971C18.0549 14.1995 18.0506 14.2057 18.0427 14.2135L17.3356 13.5064ZM17.9542 13.25C17.7221 13.25 17.4995 13.3413 17.3344 13.5077L18.044 14.2123C18.0198 14.2366 17.9863 14.25 17.9542 14.25V13.25ZM18.5732 13.5064C18.4086 13.3418 18.1874 13.25 17.9542 13.25V14.25C17.9219 14.25 17.8888 14.2362 17.8661 14.2135L18.5732 13.5064ZM21.4936 16.4278L18.5733 13.5065L17.866 14.2135L20.7864 17.1348L21.4936 16.4278ZM21.6145 16.5787C21.5784 16.5214 21.5369 16.4711 21.4936 16.4278L20.7865 17.1349C20.7821 17.1306 20.7757 17.1233 20.7686 17.112L21.6145 16.5787ZM21.7293 17.2355C21.7791 17.0095 21.7382 16.7741 21.614 16.5779L20.7691 17.1128C20.7518 17.0855 20.7459 17.0511 20.7528 17.0202L21.7293 17.2355ZM21.3453 17.7841C21.5402 17.6595 21.6778 17.4648 21.7289 17.2373L20.7532 17.0183C20.7602 16.9868 20.7808 16.9581 20.8068 16.9415L21.3453 17.7841ZM18.0801 19.8621L21.3445 17.7846L20.8076 16.941L17.5432 19.0184L18.0801 19.8621ZM18.1347 19.727C18.1473 19.7791 18.1255 19.8331 18.0803 19.8619L17.543 19.0185C17.2278 19.2193 17.0751 19.5984 17.1626 19.9614L18.1347 19.727ZM17.717 22.5879C18.2212 21.7206 18.3699 20.7032 18.1348 19.7271L17.1626 19.9613C17.3374 20.6872 17.2272 21.4407 16.8524 22.0853L17.717 22.5879ZM17.5798 22.7657C17.6314 22.714 17.6779 22.655 17.7169 22.5881L16.8525 22.0852C16.8595 22.0732 16.867 22.0642 16.8726 22.0586L17.5798 22.7657ZM16.9617 23.0211C17.1926 23.0211 17.4143 22.9311 17.5798 22.7657L16.8726 22.0586C16.8971 22.0341 16.9308 22.0211 16.9617 22.0211V23.0211ZM16.3422 22.7647C16.5073 22.9298 16.7292 23.0211 16.9617 23.0211V22.0211C16.9933 22.0211 17.0261 22.0344 17.0493 22.0576L16.3422 22.7647ZM12.2353 18.6578L16.3422 22.7647L17.0493 22.0576L12.9424 17.9507L12.2353 18.6578ZM12.0996 18.4826C12.1379 18.5476 12.1835 18.606 12.2353 18.6578L12.9424 17.9507C12.9493 17.9576 12.9559 17.966 12.9612 17.9749L12.0996 18.4826ZM12.0073 17.8177C11.9476 18.045 11.9822 18.2827 12.0992 18.482L12.9616 17.9756C12.9776 18.0028 12.9832 18.0385 12.9745 18.0719L12.0073 17.8177ZM12.4094 17.2858C12.21 17.4031 12.0662 17.5937 12.0073 17.8177L12.9745 18.0719C12.9666 18.1019 12.9458 18.1305 12.9164 18.1478L12.4094 17.2858Z",
                          fill: _vm.brandColor,
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "30",
                          y: "15",
                          width: "46",
                          height: "8",
                          rx: "2",
                          fill: "#E5E6E6",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "10",
                          y: "40",
                          width: "196",
                          height: "8",
                          rx: "2",
                          fill: "#E5E6E6",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "10",
                          y: "52",
                          width: "144",
                          height: "8",
                          rx: "2",
                          fill: "#E5E6E6",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _c(
                "g",
                {
                  staticClass: "post",
                  attrs: {
                    transform: "translate(0 " + _vm.otherPostsTop + ")",
                  },
                },
                [
                  _vm._l(4, function (i) {
                    return [
                      _c("rect", {
                        attrs: {
                          x: "8.25",
                          y: 68 * (i - 1) + 0.25,
                          width: "215.5",
                          height: "59.5",
                          rx: "3.75",
                          fill: _vm.backgroundColor3 || "#FFFFFF",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "18",
                          y: 68 * (i - 1) + 10,
                          width: "46",
                          height: "8",
                          rx: "2",
                          fill: "#E5E6E6",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "18",
                          y: 68 * (i - 1) + 30,
                          width: "196",
                          height: "8",
                          rx: "2",
                          fill: "#E5E6E6",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "18",
                          y: 68 * (i - 1) + 42,
                          width: "144",
                          height: "8",
                          rx: "2",
                          fill: "#E5E6E6",
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "8.25",
                          y: 68 * (i - 1) + 0.25,
                          width: "215.5",
                          height: "59.5",
                          rx: "3.75",
                          stroke: _vm.backgroundColor2 || "#E5E6E6",
                          "stroke-width": "0.5",
                        },
                      }),
                    ]
                  }),
                ],
                2
              ),
              _c("g", { staticClass: "bottom_bar" }, [
                _c("g", { attrs: { filter: "url(#filter0_d_941_27100)" } }, [
                  _c("path", {
                    attrs: {
                      d: "M0 410H232V442C232 446.418 228.418 450 224 450H8C3.58173 450 0 446.418 0 442V410Z",
                      fill: _vm.backgroundColor3 || "#FFFFFF",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M0.5 410.5H231.5V442C231.5 446.142 228.142 449.5 224 449.5H8C3.85787 449.5 0.5 446.142 0.5 442V410.5Z",
                      stroke: _vm.backgroundColor2 || "#E5E6E6",
                    },
                  }),
                ]),
                _c("rect", {
                  attrs: {
                    x: "16",
                    y: "420",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: _vm.isV3 ? _vm.brandColor : _vm.color5,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "61",
                    y: "420",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: _vm.foregroundColor2 || "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "106",
                    y: "420",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: _vm.foregroundColor2 || "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "151",
                    y: "420",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: _vm.foregroundColor2 || "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "196",
                    y: "420",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: _vm.foregroundColor2 || "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    y: "410",
                    width: "51",
                    height: "2",
                    rx: "1",
                    fill: _vm.isV3 ? _vm.brandColor : _vm.color5,
                  },
                }),
              ]),
              _c("g", { staticClass: "plus_button" }, [
                _c("circle", {
                  attrs: {
                    cx: "208",
                    cy: "386",
                    r: "16",
                    fill: _vm.brandColor,
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M208 394.333C207.655 394.333 207.375 394.053 207.375 393.708V386.625H200.292C199.947 386.625 199.667 386.345 199.667 386C199.667 385.655 199.947 385.375 200.292 385.375H207.375V378.292C207.375 377.947 207.655 377.667 208 377.667C208.345 377.667 208.625 377.947 208.625 378.292V385.375H215.708C216.053 385.375 216.333 385.655 216.333 386C216.333 386.345 216.053 386.625 215.708 386.625H208.625V393.708C208.625 394.053 208.345 394.333 208 394.333Z",
                    fill: "white",
                  },
                }),
              ]),
              _c("g", { staticClass: "top_bar" }, [
                _c("rect", {
                  attrs: {
                    width: "232",
                    height: "32",
                    transform: "translate(0 1)",
                    fill: _vm.isV3 ? _vm.backgroundColor1 : _vm.brandColor,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "210",
                    y: "12",
                    width: "10",
                    height: "10",
                    rx: "2",
                    fill: _vm.foregroundColor2 || _vm.color2,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "45",
                    y: "13",
                    width: "141",
                    height: "8",
                    rx: "2",
                    fill: _vm.foregroundColor2 || _vm.color2,
                  },
                }),
              ]),
            ]
          ),
          _c("rect", {
            staticClass: "page_borders",
            attrs: {
              x: "0.5",
              y: "0.5",
              width: "231",
              height: "449",
              rx: "7.5",
              stroke: _vm.backgroundColor2 || "#E5E6E6",
            },
          }),
          _c("defs", [
            _c(
              "filter",
              {
                attrs: {
                  id: "filter0_d_941_27100",
                  x: "-12",
                  y: "394",
                  width: "256",
                  height: "64",
                  filterUnits: "userSpaceOnUse",
                  "color-interpolation-filters": "sRGB",
                },
              },
              [
                _c("feFlood", {
                  attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
                }),
                _c("feColorMatrix", {
                  attrs: {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha",
                  },
                }),
                _c("feOffset", { attrs: { dy: "-4" } }),
                _c("feGaussianBlur", { attrs: { stdDeviation: "6" } }),
                _c("feComposite", {
                  attrs: { in2: "hardAlpha", operator: "out" },
                }),
                _c("feColorMatrix", {
                  attrs: {
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
                  },
                }),
                _c("feBlend", {
                  attrs: {
                    mode: "normal",
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_941_27100",
                  },
                }),
                _c("feBlend", {
                  attrs: {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_941_27100",
                    result: "shape",
                  },
                }),
              ],
              1
            ),
            _c("clipPath", { attrs: { id: "clip_page_radius" } }, [
              _c("rect", {
                attrs: { width: "232", height: "450", rx: "8", fill: "white" },
              }),
            ]),
            _c("clipPath", { attrs: { id: "clip_quick_links" } }, [
              _c("rect", {
                attrs: { width: "232", height: "60", fill: "white" },
              }),
            ]),
          ]),
        ]
      ),
    ]),
    _vm.showMobileMenu
      ? _c("div", { staticClass: "menu" }, [
          _c("h4", [
            _vm._v(_vm._s(_vm.$t("theme.editor.previews.mobile_menu"))),
          ]),
          _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 232 450",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("g", { attrs: { "clip-path": "url(#clip0_941_27181)" } }, [
                _c("rect", {
                  attrs: {
                    width: "232",
                    height: "450",
                    rx: "8",
                    fill: _vm.backgroundColor4 || _vm.color15,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "216",
                    y: "371",
                    width: "8",
                    height: "8",
                    rx: "2",
                    transform: "rotate(-180 216 371)",
                    fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "174",
                    y: "370",
                    width: "156",
                    height: "5.99999",
                    rx: "2.99999",
                    transform: "rotate(-180 174 370)",
                    fill: _vm.foregroundColor1 || _vm.color3,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "216",
                    y: "403",
                    width: "8",
                    height: "8",
                    rx: "2",
                    transform: "rotate(-180 216 403)",
                    fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "112",
                    y: "402",
                    width: "94",
                    height: "5.99999",
                    rx: "2.99999",
                    transform: "rotate(-180 112 402)",
                    fill: _vm.foregroundColor1 || _vm.color3,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "216",
                    y: "435",
                    width: "8",
                    height: "8",
                    rx: "2",
                    transform: "rotate(-180 216 435)",
                    fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "133",
                    y: "434",
                    width: "115",
                    height: "5.99999",
                    rx: "2",
                    transform: "rotate(-180 133 434)",
                    fill: _vm.foregroundColor1 || _vm.color3,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "1",
                    y: "31",
                    width: "230",
                    height: "94",
                    fill: "#FFFFFF",
                    "fill-opacity": "1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "1",
                    y: "31",
                    width: "230",
                    height: "94",
                    fill: _vm.backgroundColor3 || _vm.color14 || "#F2F2F3",
                    "fill-opacity": "1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "91",
                    width: "114",
                    height: "6",
                    rx: "3",
                    fill: _vm.foregroundColor1 || _vm.color6,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "105",
                    width: "53",
                    height: "6",
                    rx: "3",
                    fill: _vm.foregroundColor2 || _vm.color7,
                  },
                }),
                _c("g", { attrs: { filter: "url(#filter0_d_941_27181)" } }, [
                  _c("path", {
                    attrs: {
                      d: "M0 410H232V442C232 446.418 228.418 450 224 450H8C3.58173 450 0 446.418 0 442V410Z",
                      fill: _vm.backgroundColor3 || "#FFFFFF",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M0.5 410.5H231.5V442C231.5 446.142 228.142 449.5 224 449.5H8C3.85787 449.5 0.5 446.142 0.5 442V410.5Z",
                      stroke: _vm.backgroundColor2 || "#E5E6E6",
                    },
                  }),
                ]),
                _c("rect", {
                  attrs: {
                    x: "16",
                    y: "420",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: _vm.isV3 ? _vm.brandColor : _vm.color5,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "61",
                    y: "420",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: _vm.foregroundColor2 || "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "106",
                    y: "420",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: _vm.foregroundColor2 || "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "151",
                    y: "420",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: _vm.foregroundColor2 || "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "196",
                    y: "420",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: _vm.foregroundColor2 || "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    y: "410",
                    width: "51",
                    height: "2",
                    rx: "1",
                    fill: _vm.isV3 ? _vm.brandColor : _vm.color5,
                  },
                }),
                _c("g", { attrs: { transform: "translate(-80 0)" } }, [
                  _c("circle", {
                    attrs: {
                      cx: "116",
                      cy: "61",
                      r: "21",
                      fill: _vm.brandColor,
                      stroke: _vm.backgroundColor3 || _vm.color15,
                      "stroke-width": "2",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M105.367 67H107.625V59.7891H107.75L112.969 67H114.922V55.7266H112.664V62.9062H112.539L107.336 55.7266H105.367V67ZM121.695 67.2891C124.508 67.2891 126.242 65.875 126.242 63.6406V63.6328C126.242 61.875 125.203 60.9219 122.82 60.4297L121.625 60.1875C120.297 59.9141 119.75 59.4766 119.75 58.7422V58.7344C119.75 57.8906 120.523 57.3594 121.688 57.3516C122.875 57.3516 123.656 57.9141 123.789 58.7188L123.805 58.8125H126.023L126.016 58.7109C125.867 56.8281 124.32 55.4375 121.688 55.4375C119.188 55.4375 117.391 56.8203 117.391 58.9141V58.9219C117.391 60.6328 118.398 61.7266 120.742 62.2031L121.93 62.4453C123.328 62.7344 123.883 63.1484 123.883 63.8906V63.8984C123.883 64.7656 123.016 65.3672 121.758 65.3672C120.438 65.3672 119.523 64.7969 119.438 63.9531L119.43 63.875H117.156L117.164 64C117.297 66 119 67.2891 121.695 67.2891Z",
                      fill: _vm.color2,
                    },
                  }),
                ]),
                _c("rect", {
                  attrs: {
                    x: "216",
                    y: "177",
                    width: "8",
                    height: "8",
                    rx: "2",
                    transform: "rotate(-180 216 177)",
                    fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "174",
                    y: "176",
                    width: "156",
                    height: "5.99999",
                    rx: "2.99999",
                    transform: "rotate(-180 174 176)",
                    fill: _vm.foregroundColor1 || _vm.color3,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "216",
                    y: "209",
                    width: "8",
                    height: "8",
                    rx: "2",
                    transform: "rotate(-180 216 209)",
                    fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "112",
                    y: "208",
                    width: "94",
                    height: "5.99999",
                    rx: "2.99999",
                    transform: "rotate(-180 112 208)",
                    fill: _vm.foregroundColor1 || _vm.color3,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "216",
                    y: "241",
                    width: "8",
                    height: "8",
                    rx: "2",
                    transform: "rotate(-180 216 241)",
                    fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "133",
                    y: "240",
                    width: "115",
                    height: "5.99999",
                    rx: "2.99999",
                    transform: "rotate(-180 133 240)",
                    fill: _vm.foregroundColor1 || _vm.color3,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "216",
                    y: "273",
                    width: "8",
                    height: "8",
                    rx: "2",
                    transform: "rotate(-180 216 273)",
                    fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "174",
                    y: "272",
                    width: "156",
                    height: "5.99999",
                    rx: "2.99999",
                    transform: "rotate(-180 174 272)",
                    fill: _vm.foregroundColor1 || _vm.color3,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "216",
                    y: "305",
                    width: "8",
                    height: "8",
                    rx: "2",
                    transform: "rotate(-180 216 305)",
                    fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "122",
                    y: "304",
                    width: "104",
                    height: "5.99999",
                    rx: "2.99999",
                    transform: "rotate(-180 122 304)",
                    fill: _vm.foregroundColor1 || _vm.color3,
                  },
                }),
                _c("rect", {
                  attrs: {
                    width: "230",
                    height: "14",
                    transform: "translate(1 135)",
                    fill: _vm.backgroundColor4 || _vm.color10,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "173",
                    y: "145",
                    width: "156",
                    height: "5.99999",
                    rx: "2.99999",
                    transform: "rotate(-180 173 145)",
                    fill: _vm.foregroundColor1 || _vm.color11,
                  },
                }),
                _c("rect", {
                  attrs: {
                    width: "230",
                    height: "14",
                    transform: "translate(1 329)",
                    fill: _vm.backgroundColor4 || _vm.color10,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "173",
                    y: "339",
                    width: "156",
                    height: "5.99999",
                    rx: "2.99999",
                    transform: "rotate(-180 173 339)",
                    fill: _vm.foregroundColor1 || _vm.color11,
                  },
                }),
              ]),
              _c("rect", {
                attrs: {
                  x: "0.5",
                  y: "0.5",
                  width: "231",
                  height: "449",
                  rx: "7.5",
                  stroke: _vm.backgroundColor2 || "#E5E6E6",
                },
              }),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "filter0_d_941_27181",
                      x: "-12",
                      y: "394",
                      width: "256",
                      height: "64",
                      filterUnits: "userSpaceOnUse",
                      "color-interpolation-filters": "sRGB",
                    },
                  },
                  [
                    _c("feFlood", {
                      attrs: {
                        "flood-opacity": "0",
                        result: "BackgroundImageFix",
                      },
                    }),
                    _c("feColorMatrix", {
                      attrs: {
                        in: "SourceAlpha",
                        type: "matrix",
                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                        result: "hardAlpha",
                      },
                    }),
                    _c("feOffset", { attrs: { dy: "-4" } }),
                    _c("feGaussianBlur", { attrs: { stdDeviation: "6" } }),
                    _c("feComposite", {
                      attrs: { in2: "hardAlpha", operator: "out" },
                    }),
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
                      },
                    }),
                    _c("feBlend", {
                      attrs: {
                        mode: "normal",
                        in2: "BackgroundImageFix",
                        result: "effect1_dropShadow_941_27181",
                      },
                    }),
                    _c("feBlend", {
                      attrs: {
                        mode: "normal",
                        in: "SourceGraphic",
                        in2: "effect1_dropShadow_941_27181",
                        result: "shape",
                      },
                    }),
                  ],
                  1
                ),
                _c("clipPath", { attrs: { id: "clip0_941_27181" } }, [
                  _c("rect", {
                    attrs: {
                      width: "232",
                      height: "450",
                      rx: "8",
                      fill: "white",
                    },
                  }),
                ]),
              ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/theme/MobilePreview.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__